import { Record } from 'immutable';

class CrossChannelMode extends Record(
  {
    key: '',
    displayLabel: '',
    selected: true,
    cost: '',
    frequency: '',
    percentage: '',
    discount: '',
    percentageType: '',
    impactFactor: '',
    flightSize: '',
    costText: '',
    costTooltip: '',
    frequencyText: '',
    frequencyTooltip: '',
    percentText: '',
    percentTooltip: '',
    impactFactorText: '',
    impactFactorTooltip: '',
    discountTooltip: '',
    flightText: '',
    flightTooltip: '',
    icon: '',
  }) {

  get validCost() {
    return (!isNaN(parseFloat(this.cost)) && isFinite(this.cost));
  }

  get validPercentage() {
    return this.percentage !== undefined && this.percentage !== '' ?
      this.percentageType !== undefined && this.percentageType !== '' :
      true;
  }

  get validFrequencyCap() {
    return this.frequency === undefined ||
           this.frequency === '' ||
           this.frequency === null ||
           this.frequency > 0;
  }

  get valid() {
    return this.key !== undefined
      && this.validCost
      && this.validPercentage
      && this.validFrequencyCap;
  }

  get costJson() {
    return this.cost !== undefined && this.cost !== ''
      ? { mode: this.key, cost: Number(this.cost) }
      : null;
  }

  get frequencyCapJson() {
    return this.frequency !== undefined && this.frequency !== '' && this.frequency > 0
      ? { mode: this.key, cap: Number(this.frequency) }
      : null;
  }

  get impactScalingJson() {
    return this.impactFactor !== undefined && this.impactFactor !== ''
      ? { mode: this.key, factor: Number(this.impactFactor) }
      : null;
  }

  get budgetConstraintJson() {
    return this.percentage !== undefined && this.percentage !== ''
      ? { mode: this.key, percent: Number(this.percentage / 100), type: this.percentageType }
      : null;
  }

}

export default CrossChannelMode;
